import { HIDDEN_TEASER_STATE_CLASS, TRIGGER_SELECTOR } from '../../constants/topic-list'

class TopicTeaser {
  constructor(el) {
    this.teaser = el
  }

  show() {
    this.teaser.classList.remove(HIDDEN_TEASER_STATE_CLASS)
  }

  hide() {
    this.teaser.classList.add(HIDDEN_TEASER_STATE_CLASS)
  }

  retrieveTitleText() {
    const teaserTitleEl = this.teaser.querySelector(TRIGGER_SELECTOR)

    return {
      teaser: this.teaser,
      teaserText: teaserTitleEl.innerHTML,
    }
  }

  retrieveFirstLetterOfTitle() {
    return this.teaser
      .querySelector(TRIGGER_SELECTOR)
      .innerHTML.trim()
      .charAt(0)
      .toUpperCase()
  }

  isUncollapsed() {
    return !!this.teaser.querySelector(TRIGGER_SELECTOR).getAttribute('data-uncollapsed')
  }
}

export default TopicTeaser
